import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { RootState } from "store/store";
import { UserTypeEnum } from "common/enums/UserType.enum";
import { message } from "antd";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userData } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const userTypeLabel = pathSegments[0];

  useEffect(() => {
    if (!userData) return;

    if (
      userTypeLabel === "buyer" &&
      userData.type === UserTypeEnum.COMPANY_SELLER
    ) {
      // buyer not access seller page
      message.error("買い手アカウントは売り手ページにアクセスできません。");
      navigate("/seller/dashboard", { replace: true });
      return;
    }

    if (
      userTypeLabel === "seller" &&
      userData.type === UserTypeEnum.COMPANY_BUYER
    ) {
      // seller not access buyer page
      message.error("売り手アカウントは買い手ページにアクセスできません。");
      navigate("/buyer/dashboard", { replace: true });
      return;
    }

    if (userData.type === UserTypeEnum.ADMIN && userTypeLabel !== "admin") {
      // admin not access this page
      message.error("管理者権限が必要です。");
      navigate("/admin/dashboard", { replace: true });
      return;
    }
  }, [userData, userTypeLabel, navigate]);

  if (!userData) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
